import { useNavigate } from "@tanstack/react-router"

import { Button } from "@productlane/ui"

import { SettingsContainer } from "@/screens/settings/settings-switches/settings-container"
import { SettingsHeader } from "../../settings-header"
import { AttachmentImportForm } from "./attachment-import-form"

export function AttachmentImportPage() {
	const navigate = useNavigate()
	return (
		<>
			<SettingsHeader title="Linear attachment import" subtitle={null} />

			<SettingsContainer>
				<AttachmentImportForm
					errorContent={null}
					successContent={
						<Button
							onClick={() => {
								void navigate({ href: `/threads?state=processed` })
							}}
						>
							View insights
						</Button>
					}
				/>
			</SettingsContainer>
		</>
	)
}
